/**
 * Builds the /v1/billing/end-trial request body for the trial-upgrade paywall.
 *
 * Pure so the guard logic is unit-testable: every omitted field falls back to
 * the server's carry-forward behavior (keep the subscription's current pack /
 * interval), which is always the safe choice when the client isn't SURE the
 * value reflects user intent or real data:
 *
 *  - `aiCreditPack` is sent only when the user explicitly picked a pack or the
 *    committed-pack default genuinely loaded from plan-summary. Otherwise the
 *    picker may still show its placeholder minimum, and sending it would
 *    silently downgrade the org's pack at conversion.
 *  - `billingInterval` is sent only when the user touched the toggle or the
 *    org's interval is actually known. The toggle DEFAULTS to annual when the
 *    org DTO interval is null, so sending that guess would silently flip a
 *    monthly subscription (and re-price every line item) to annual.
 */
export function buildEndTrialRequestBody({
  isSeatless,
  seats,
  selectedPackCredits,
  isAnnual,
  userPickedPack,
  committedPackLoaded,
  userTouchedInterval,
  orgIntervalKnown,
}: {
  isSeatless: boolean;
  seats: number;
  selectedPackCredits: number;
  isAnnual: boolean;
  userPickedPack: boolean;
  committedPackLoaded: boolean;
  userTouchedInterval: boolean;
  orgIntervalKnown: boolean;
}): {
  builderSeats?: number;
  aiCreditPack?: number;
  billingInterval?: "annual" | "monthly";
} {
  return {
    ...(isSeatless
      ? userPickedPack || committedPackLoaded
        ? { aiCreditPack: selectedPackCredits }
        : {}
      : { builderSeats: seats }),
    ...(userTouchedInterval || orgIntervalKnown
      ? {
          billingInterval: isAnnual
            ? ("annual" as const)
            : ("monthly" as const),
        }
      : {}),
  };
}
